var React = require('react');

function Time (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"className":"svg-circle","id":"Ellipse 338","cx":"15","cy":"17.2963","r":"15","fill":"#FEBE10","key":0}),React.createElement("path",{"id":"Vector","d":"M19.6585 21.5557L15.3274 17.2246V7.29097C15.3274 6.97847 15.073 6.72403 14.7605 6.72403C14.448 6.72403 14.1938 6.97847 14.1938 7.29097V17.6424L14.168 17.6682L14.1938 17.694V17.724L14.2252 17.7254L18.8569 22.3571C18.9635 22.4638 19.1057 22.5224 19.2577 22.5224C19.4096 22.5224 19.5519 22.4638 19.6585 22.3571C19.7652 22.2504 19.8238 22.1082 19.8238 21.9563C19.8238 21.8043 19.7652 21.6621 19.6585 21.5554V21.5557Z","fill":"white","key":1}),React.createElement("defs",{"key":2},React.createElement("rect",{"width":"30","height":"32","fill":"white","transform":"translate(0 0.296295)"}))]);
}

Time.defaultProps = {"width":"30","height":"33","viewBox":"0 0 30 33","fill":"none"};

module.exports = Time;

Time.default = Time;
